/**
 * AssessorSidebar - Sidebar do painel de assessores
 *
 * Refatorado para usar BaseSidebar compartilhado
 */

import React from 'react';
import {
  TrendingUp,
  Briefcase,
  Megaphone,
  FileText,
  Wallet,
} from 'lucide-react';
import { BaseSidebar, NavigationItem } from './BaseSidebar';

interface AssessorSidebarProps {
  onSidebarToggle?: (open: boolean) => void;
}

export const AssessorSidebar: React.FC<AssessorSidebarProps> = ({ onSidebarToggle }) => {
  const navigationItems: NavigationItem[] = [
    {
      label: 'Dashboard',
      href: '/assessor/dashboard',
      icon: <TrendingUp className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Minha Carteira',
      href: '/assessor/carteira',
      icon: <Wallet className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Produtos Gerais',
      href: '/products',
      icon: <Briefcase className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Comunicados',
      href: '/assessor/comunicados',
      icon: <Megaphone className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Documentos',
      href: '/assessor/documentos',
      icon: <FileText className="text-sidebar-foreground size-4 shrink-0" />,
    },
  ];

  return (
    <BaseSidebar
      navigationItems={navigationItems}
      profilePath="/assessor/profile"
      onSidebarToggle={onSidebarToggle}
    />
  );
};

export default AssessorSidebar;
